import { addReadyPromise } from './util/utilities';

export default class Readyable {
	constructor() {
		const { isReady, onReadyReject, onReadyResolve } = addReadyPromise();

		/** @type {Promise<any>} */
		this.isReady = isReady;
		/** @type {Function} */
		this.onReadyResolve = onReadyResolve;
		/** @type {Function} */
		this.onReadyReject = onReadyReject;
	}
}
